module.exports = __webpack_public_path__ + "img/ta1.61be1aab.png";